import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Multipleselectdropdown, DatePicker } from "components";
import { downloadLogs, setIsOpen, showSuccess } from "store/globalSlice";
import { map } from "lodash";
import moment from "moment";
import { icons } from "utils/constants";

const Logs = ({ isDarkMode, data, staticOption }) => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { isOpen } = reduxData || {};
  const [btnLoading, setBtnLoading] = useState(false);
  const [projects, setProjects] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const downloadCsv = (fileName, csvData) => {
    const csvContent =
      "data:text/csv;charset=utf-8," + encodeURIComponent(csvData);
    const link = document.createElement("a");
    link.setAttribute("href", csvContent);
    link.setAttribute("download", `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownload = async () => {
    setBtnLoading(true);
    let payload = {
      projectids: projects,
    };
    if (from && to) {
      payload.startdate = from;
      payload.enddate = to;
    }
    const response = await dispatch(
      downloadLogs(new URLSearchParams(payload).toString())
    );
    const fileName = response?.contentDisposition
      ? response?.contentDisposition
          .replace(`attachment; filename="`, "")
          .replace(`"`, "")
      : "logs";
    if (response?.status === 200) {
      downloadCsv(fileName, response?.data);
      dispatch(setIsOpen(false));
      dispatch(showSuccess("Logs download successfully."));
    }
    setBtnLoading(false);
  };
  const handleProjectChange = (e) => {
    let newList = projects ? projects?.split(",") : [];
    if (newList?.includes(e)) {
      newList = newList.filter((o) => o !== e);
    } else {
      newList = [...newList, e];
    }
    setProjects(newList.toString());
  };
  let dropdownList = data?.map((e) => {
    return {
      id: `${e.project_id}`,
      label: e.name,
    };
  });
  useEffect(() => {
    setBtnLoading(false);
    if (staticOption) {
      setProjects(staticOption);
    } else {
      setProjects(map(data, "project_id").join(",") || "");
    }
    setFrom("");
    setTo("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  return (
    <>
      {isOpen && (
        <Modal
          width="500px"
          title="Download Logs"
          onHide={() => {
            dispatch(setIsOpen(false));
          }}
          isDarkMode={isDarkMode}
        >
          <form className="row cps-26 cpe-26 cpt-26">
            <div className="d-flex cmb-24">
              <div className="d-flex gap-2">
                <span className="d-flex h-20 w-20">
                  <img
                    src={isDarkMode ? icons.infoCircleLight : icons.infoCircle}
                    alt="infoCircle"
                    className="fit-image"
                  />
                </span>
                <span
                  className={`text-14-400 ${
                    isDarkMode ? "color-ffff" : "color-2749"
                  } un`}
                >
                  All logs will be downloaded if no date range is specified.
                </span>
              </div>
            </div>
            <div className="cmb-24">
              <Multipleselectdropdown
                staticOption={staticOption}
                isDarkMode={isDarkMode}
                label="Projects"
                title="project"
                value={projects}
                options={dropdownList}
                onChange={handleProjectChange}
              />
              {!projects && (
                <div className="input-error">Project is required</div>
              )}
            </div>
            <div className="col-md-6 cmb-24">
              <DatePicker
                isDarkMode={isDarkMode}
                isClearable
                value={from}
                id="from"
                label="From"
                placeholder="Select date"
                minDate={moment("01-11-2023", "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )}
                maxDate={moment().format("YYYY-MM-DD")}
                onChange={(e) => {
                  setFrom(e.target.value);
                  setTo("");
                }}
              />
              {to && !from && (
                <div className="input-error">From date is required</div>
              )}
            </div>
            <div className="col-md-6 cmb-24">
              <DatePicker
                isDarkMode={isDarkMode}
                isClearable
                minDate={from}
                maxDate={moment().format("YYYY-MM-DD")}
                value={to}
                id="to"
                label="To"
                placeholder="Select date"
                onChange={(e) => {
                  setTo(e.target.value);
                }}
              />
              {from && !to && (
                <div className="input-error">End date is required</div>
              )}
            </div>
            <div className="d-flex justify-content-end mt-1">
              <Button
                btnStyle="PD"
                onClick={() => {
                  if (!btnLoading) {
                    handleDownload();
                  }
                }}
                loading={btnLoading}
                btnText="Download"
                disabled={
                  projects
                    ? (from && !to) || (to && !from)
                      ? true
                      : false
                    : true
                }
              />
            </div>
          </form>
        </Modal>
      )}
      {/* <Button
        btnStyle="PO"
        className={isDarkMode ? "bg-tr" : ""}
        btnText="Download Logs"
        onClick={() => {
          setIsOpen(true);
        }}
      /> */}
    </>
  );
};

export default Logs;
